import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { defaultEditFormState } from "../constant";
import { MembershipAPI } from "../../api/membership";
import { IconButton, Stack, useMediaQuery } from "@mui/material";
import VisibilityIcon from "../../assets/SVGs/Login/VisibilityIcon";
import dayjs from "dayjs";

import { DataGrid } from "@mui/x-data-grid";
import EditMeetUpModal from "../Modal/EditMeetUpModal";

const MemeberMeetUpTab = ({ id }) => {
  const isMobileTable = useMediaQuery("(max-width:850px)");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(defaultEditFormState);

  const fetchMembers = async () => {
    setIsLoading(true);
    try {
      setData(await MembershipAPI.getMeetUp(id));
    } catch (e) {
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    isLoading && fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, isLoading]);

  const columns = [
    {
      field: "meetup_date",
      headerName: "Meet-Up Date",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate(); // returns a native JS Date
      },
      renderCell: (params) => dayjs(params.value).format("MM/DD/YYYY"),
    },
    {
      field: "added_active_members",
      headerName: "Members",
      flex: 1,
      minWidth: isMobileTable ? 350 : undefined,
      renderCell: (params) =>
        params?.row?.added_active_members
          ?.map((member) => `${member.first_name} ${member.last_name}`)
          .join(", ") || "No members",

      valueGetter: (params) =>
        params
          ?.map((member) => `${member.first_name} ${member.last_name}`)
          .join(", ") || "",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="view"
          size="small"
          onClick={() =>
            setOpenEditModal({
              open: true,
              id: params?.row?.id,
              title: dayjs(params?.row?.meetup_date).format("MM/DD/YYYY"),
            })
          }
        >
          <VisibilityIcon
            sx={{
              color: "#64748B",
            }}
          />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <div className="sub-header">Meet-Ups Attendance</div>
      <Stack
        sx={{
          width: "100%",
          "& .MuiDataGrid-root": {
            borderRadius: "8px",
            overflowX: "auto",
          },
        }}
        className="customDataGridFigma"
      >
        <DataGrid
          rows={data?.items || []}
          columns={columns}
          loading={isLoading}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          checkboxSelection={false}
          rowSelection={false}
          rowHeight={48}
          columnHeaderHeight={40}
          getRowClassName={(params) => {
            const customClassName =
              params.indexRelativeToCurrentPage % 2 !== 0 ? "bg-gray" : "";
            return ` ${customClassName}`.trim();
          }}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "linear-progress",
            },
          }}
          localeText={{
            noRowsLabel: "No Meet-Ups found.",
          }}
          disableVirtualization
        />
        {openEditModal?.open && (
          <EditMeetUpModal
            open={openEditModal?.open}
            id={openEditModal?.id}
            handleClose={() => setOpenEditModal(defaultEditFormState)}
            setIsLoading={setIsLoading}
            title={openEditModal?.title}
          />
        )}
      </Stack>
    </>
  );
};

export default MemeberMeetUpTab;
